import React, { useState, useRef } from 'react';
import useClickOutside from '../../hooks/useClickOutside';
// --- INÍCIO DA ALTERAÇÃO: Removido o hook de arrastar ---
// import useDraggable from '../../hooks/useDraggable';
// --- FIM DA ALTERAÇÃO ---

const CustomDatePicker = ({ value, onChange }) => {
    const [currentDate, setCurrentDate] = useState(value ? new Date(value) : new Date());
    // --- INÍCIO DA ALTERAÇÃO: Removidas as referências e estados de arrastar ---
    // const dragHandleRef = useRef(null);
    // const { draggableRef } = useDraggable(dragHandleRef); // Removido
    const datePickerRef = useRef(null); // Ref para o container principal
    // --- FIM DA ALTERAÇÃO ---

    const daysOfWeek = ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'];
    const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

    const changeMonth = (offset) => {
        setCurrentDate(prev => {
            const newDate = new Date(prev);
            newDate.setMonth(newDate.getMonth() + offset);
            return newDate;
        });
    };

    const handleDayClick = (day) => {
        const selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        const timeZoneOffset = selectedDate.getTimezoneOffset() * 60000;
        const adjustedDate = new Date(selectedDate.getTime() - timeZoneOffset);
        const formattedDate = adjustedDate.toISOString().split('T')[0];
        onChange(formattedDate);
    };

    const getStartOfWeek = (date) => {
        const d = new Date(date);
        const day = d.getDay();
        const diff = d.getDate() - day;
        const startOfWeek = new Date(d.setDate(diff));
        startOfWeek.setHours(0, 0, 0, 0);
        return startOfWeek;
    };

    const generateCalendarDays = () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();
        const firstDayOfMonth = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const selectedValueDate = value ? new Date(value) : null;
        if (selectedValueDate) {
            const tzOffset = selectedValueDate.getTimezoneOffset() * 60000;
            selectedValueDate.setTime(selectedValueDate.getTime() + tzOffset);
            selectedValueDate.setHours(0,0,0,0);
        }

        const startOfCurrentWeek = getStartOfWeek(today);
        
        let days = [];
        for (let i = 0; i < firstDayOfMonth; i++) {
            days.push(<div key={`empty-${i}`} className="w-8 h-8"></div>);
        }
        for (let day = 1; day <= daysInMonth; day++) {
            const dayDate = new Date(year, month, day);
            dayDate.setHours(0, 0, 0, 0);
            const isSelected = selectedValueDate && dayDate.getTime() === selectedValueDate.getTime();
            const isToday = today.getTime() === dayDate.getTime();
            const isCurrentWeek = getStartOfWeek(dayDate).getTime() === startOfCurrentWeek.getTime();
            let dayClasses = 'w-8 h-8 flex items-center justify-center rounded-full text-sm transition-colors ';
            if (isSelected) { dayClasses += 'bg-indigo-500 text-white font-bold scale-110 shadow-lg'; } 
            else if (isToday) { dayClasses += 'border-2 border-emerald-500 text-emerald-300'; } 
            else if (isCurrentWeek) { dayClasses += 'bg-white/5 hover:bg-white/15 text-slate-200'; } 
            else { dayClasses += 'hover:bg-white/20 text-slate-400'; }
            days.push(<button key={day} onClick={() => handleDayClick(day)} className={dayClasses}>{day}</button>);
        }
        return days;
    };

    return (
        // --- INÍCIO DA ALTERAÇÃO: Removido draggableRef ---
        <div ref={datePickerRef} className="w-72 max-w-[90vw] text-white">
        {/* --- FIM DA ALTERAÇÃO --- */}
             <div className="bg-slate-800/80 backdrop-blur-lg p-4 rounded-lg border border-white/20 shadow-lg">
                {/* --- INÍCIO DA ALTERAÇÃO: Removidas as props de arrastar --- */}
                <div className="flex justify-between items-center mb-3">
                {/* --- FIM DA ALTERAÇÃO --- */}
                    <button onClick={(e) => {e.preventDefault(); changeMonth(-1)}} className="p-1 rounded-full hover:bg-white/20">&lt;</button>
                    <span className="font-semibold text-white select-none">{monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}</span>
                    <button onClick={(e) => {e.preventDefault(); changeMonth(1)}} className="p-1 rounded-full hover:bg-white/20">&gt;</button>
                </div>
                <div className="grid grid-cols-7 gap-1 text-center text-xs text-slate-400">
                    {daysOfWeek.map((day, index) => <div key={`${day}-${index}`} className="select-none">{day}</div>)}
                </div>
                <div className="grid grid-cols-7 gap-1 mt-2 text-center">
                    {generateCalendarDays()}
                </div>
            </div>
        </div>
    );
};

export default CustomDatePicker;